let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l8wus")).then(() => parcelRequire('5TpHi'));